import React, { useState, useEffect, useRef } from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ReferenceArea, ReferenceLine } from 'recharts';

const SewageDischargeStationSpillHistoryChart = function({ sewageHistory }) {
	const [chartWidth, setChartWidth] = useState(0);
	const chartContainerRef = useRef(null);
	useEffect(() => {
		const handleResize = () => {
		  if (chartContainerRef.current) {
		    setChartWidth(chartContainerRef.current.offsetWidth);
		  }
		};

		// Set initial width
		handleResize();

		// Add resize event listener
		window.addEventListener('resize', handleResize);

		// Remove event listener on cleanup
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	if(!sewageHistory) {
		return <span>No History Chart Available</span>
	}
	

	let years = Object.keys(sewageHistory).sort();

	const chartData = years.reduce(function(acca, year) {
		const yearData = sewageHistory[year];

		let hrs = parseFloat(yearData.declaredDurationHours);
		hrs = isNaN(hrs) ? 0 : hrs;
		let spls = parseInt(yearData.declaredCountedSpills);
		spls = isNaN(spls) ? 0 : spls;

		acca.push({
			year: year,
			hours: hrs,
			spills: spls
		});
		return acca;
	}, []);

	return  <>
    <div ref={chartContainerRef} style={{ width: '100%', height: '300px' }}>
      <LineChart
        width={chartWidth}
        height={300}
        data={chartData}
        margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
      >
        <XAxis dataKey="year" label={{ value: 'Year', position: 'insideBottomRight', offset: -10 }} />
        <YAxis yAxisId="left" label={{ value: 'Total Hours', angle: -90, position: 'insideLeft' }} />
        <YAxis yAxisId="right" orientation="right" label={{ value: 'Spills', angle: 90, position: 'insideRight' }} />
        <Tooltip />
        <Legend />
        <Line type="monotone" dataKey="hours" stroke="#000000" name="Total Hours" yAxisId="left" />
        <Line type="monotone" dataKey="spills" stroke="#FF0000" name="Spill Count" yAxisId="right" />
      </LineChart>
    </div>
  </>;
}

export default SewageDischargeStationSpillHistoryChart;